import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Target } from "@phosphor-icons/react";
import { API, setToken, setKind } from "@/lib/api";
import { OWNER } from "@/constants/testIds";
import axios from "axios";

export default function OwnerLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const params = new URLSearchParams();
      params.set("username", email);
      params.set("password", password);
      const r = await axios.post(`${API}/auth/owner/login`, params, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      setToken(r.data.access_token);
      setKind("owner");
      toast.success("ACCESS GRANTED");
      nav("/owner");
    } catch (err) {
      let d = err?.response?.data?.detail;
      if (Array.isArray(d)) d = d.map((e) => e?.msg || "").join(", ");
      else if (typeof d !== "string") d = null;
      toast.error(d || "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="grain absolute inset-0 pointer-events-none" />
      <div className="w-full max-w-md relative">
        <Link to="/" className="kbd-label text-white/50 hover:text-neon-cyan">← BACK</Link>
        <div className="card-tactical p-8 mt-4">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-neon-cyan flex items-center justify-center">
              <Target size={22} weight="bold" color="#050505" />
            </div>
            <div>
              <div className="kbd-label text-neon-cyan">OWNER CONSOLE</div>
              <h1 className="display-heading font-black text-2xl">Authenticate</h1>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <div className="kbd-label mb-2">EMAIL</div>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid={OWNER.loginEmail}
                className="w-full bg-black/60 border border-white/10 px-4 py-3 font-mono text-sm focus:outline-none focus:border-neon-cyan"
                placeholder="owner@server.local"
              />
            </div>
            <div>
              <div className="kbd-label mb-2">PASSWORD</div>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid={OWNER.loginPassword}
                className="w-full bg-black/60 border border-white/10 px-4 py-3 font-mono text-sm focus:outline-none focus:border-neon-cyan"
                placeholder="••••••••••"
              />
            </div>
            <button
              type="submit"
              disabled={busy}
              data-testid={OWNER.loginSubmit}
              className="neon-btn w-full py-3 mt-2 disabled:opacity-50"
            >
              {busy ? "AUTHENTICATING…" : "ENTER CONSOLE"}
            </button>
          </form>
          <p className="mt-6 kbd-label text-white/40">
            SEED CREDENTIALS ARE PROVISIONED VIA <span className="text-neon-cyan">.env</span>
          </p>
        </div>
      </div>
    </div>
  );
}
